export default __webpack_public_path__ + "static/media/ae.3cb683e7.svg";